// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/ndb-characteristics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/ndb-characteristics/ndb-accuracy.js';
import g1 from '../lessons/navigation/ndb-characteristics/ndb-characteristics.js';
import g2 from '../lessons/navigation/ndb-characteristics/ndb-identification-class.js';

mount([g0, g1, g2]);
